// src/components/PrivateRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { appName } from '../Constant';

const loadingStyle = {
  minHeight: '100dvh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1rem',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
};

const spinnerStyle = {
  width: '44px',
  height: '44px',
  border: '3px solid rgba(255,255,255,0.3)',
  borderTop: '3px solid white',
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
};

const brandStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  fontSize: '1.4rem',
  fontWeight: '800',
  color: 'white',
  letterSpacing: '-0.5px',
};

const logoStyle = {
  width: '2rem',
  height: '2rem',
  objectFit: 'contain',
};

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loadingAuth, userType, isSubscriptionExpired } = useAuth();
  const location = useLocation();

  if (loadingAuth) {
    return (
      <div style={loadingStyle}>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        <div style={spinnerStyle} aria-hidden="true" />
        <span style={brandStyle}>
          <span className="logo-icon">⚡</span>
          {appName}
        </span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // CA user trying to access normal user routes → redirect to CA dashboard
  if (userType === 'ca' && !location.pathname.startsWith('/ca/') && !location.pathname.startsWith('/settings')) {
    return <Navigate to="/ca/dashboard" replace />;
  }

  // Normal user trying to access CA routes → redirect to their dashboard
  if (userType !== 'ca' && location.pathname.startsWith('/ca/')) {
    return <Navigate to="/dashboard" replace />;
  }

  // Expired subscription — only settings is accessible for renewal
  if (isSubscriptionExpired && !location.pathname.startsWith('/settings')) {
    return <Navigate to="/settings?tab=subscription" replace />;
  }

  return children;
};

export default PrivateRoute;
